/**
 * Runtime configuration utilities for the SPA
 * Provides access to deployment-time injected configuration
 */

export interface RuntimeConfig {
  API_BASE_URL: string;
}

/**
 * Get the runtime configuration
 * This configuration is injected during deployment
 */
export function getRuntimeConfig(): RuntimeConfig {
  // Check if runtime config is available
  if (typeof window !== 'undefined' && window.CONFIG?.API_BASE_URL) {
    return {
      API_BASE_URL: window.CONFIG.API_BASE_URL
    };
  }

  // Fallback to environment variables for development
  const viteApiUrl = import.meta.env.VITE_API_BASE_URL;
  if (viteApiUrl) {
    return {
      API_BASE_URL: viteApiUrl
    };
  }

  // Development fallback
  if (typeof window !== 'undefined') {
    const currentHost = window.location.hostname;
    
    if (currentHost.includes('localhost') || currentHost.includes('127.0.0.1')) {
      return {
        API_BASE_URL: '/api'
      };
    }
  }

  // If we're in production without proper config, this is an error
  throw new Error('Runtime configuration not available. API_BASE_URL must be configured during deployment.');
}

/**
 * Check if runtime configuration is properly initialized
 */
export function isConfigInitialized(): boolean {
  try {
    getRuntimeConfig();
    return true;
  } catch {
    return false;
  }
}